import { useState, createContext, useEffect } from 'react';
import axios from 'axios';

import {api_path} from '../server.js'; 

export const AuthContext = createContext({});

function AuthProvider({ children }){

    //const [user, setUser] = useState({id:1, nome:'Nivaldo Jr'});
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [loadingAuth, setLoadingAuth] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(()=>{

        function loadStorage(){
            const storageUser = localStorage.getItem("SistemaUser");

            if(storageUser){
                setUser(JSON.parse(storageUser));
                setLoading(false);
            }
            setLoading(false);
        }

        loadStorage();

    }, [])


    //login do usuario
    async function signIn(email, password){
        setLoadingAuth(true);

        let dados  = {End: email, Str: password}
        const body = {
            acao: 'login',
            dados
          }
          
          axios.post(api_path()+'sistema/cliente.login.php', body, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then(async (response) => {
            
            let usuarioId = response.data.user_codigo;
            let usuarioToken = response.data.user_token;
            let user_liberado = response.data.user_liberado;
            let user_msg = response.data.user_msg;
            //console.log(body);
            let dataUser = {
                user_id: response.data.user_codigo,
                user_email: response.data.user_email,
                user_nome: response.data.user_nome,
                user_token: response.data.user_token,
                solo_id: null
              };
              //console.log(dataUser);
              
            if(user_liberado===true){
                    setUser(dataUser);
                    storageUser(dataUser);
                    setToken(usuarioToken);
                    setLoadingAuth(false);
                }else{
                    signOut();
                    alert(user_msg);
                    setLoadingAuth(false);
                }

              
            /*
            if(usuarioId){
                    setUser(dataUser);
                    storageUser(dataUser);
                    setToken(usuarioToken);
                    setLoadingAuth(false);
                }else{
                    signOut();
                    alert('email ou senha invalidos.');
                    setLoadingAuth(false);
                }
            */

        })
        .catch(function (response) {
          //handle error
          console.log(response);
          setLoadingAuth(false);
        });

    }

    function storageUser(data){
        localStorage.setItem('SistemaUser', JSON.stringify(data));
        console.log(data);
      }

    //Logout do usuario
    async function signOut(){
        localStorage.removeItem('SistemaUser');
        setUser(null);
    }




    return(
        <AuthContext.Provider 
        value={{ 
          signed: !!user,  
          /*signed: false,*/
          user, 
          loading, 
          signIn,
          signOut,
          loadingAuth
        }}
        >
          {children}
        </AuthContext.Provider>
      )


}

export default AuthProvider;